import VueBusiness from "@/business/VueBusiness.js";
import DominioBusiness from "@/business/protocolo/DominioBusiness";

const dominiosLegado = [
  {id: 'PROTOCOLO_NOTAS', nome: 'Protocolo TN', tipo: 'PROTOCOLO', atribuicao: 'NOTAS', genero: 'o', nomeCompleto: 'Protocolo TN'},
];

export default {

  getAtribuicoes(){
    return [
      {id: 'RI', nome: 'RI', nomeCompleto: 'Registro de Imóveis'},
      {id: 'RTD', nome: 'RTD', nomeCompleto: 'Registro de Títulos e Documentos'},
      {id: 'RCPJ', nome: 'RCPJ', nomeCompleto: 'Registro Civil de Pessoas Jurídicas'},
      {id: 'NOTAS', nome: 'TN', nomeCompleto: 'Tabelionato de Notas'},
    ];
  },

  getAtribuicoesAtivas(){
    return DominioBusiness.getAtribuicoes().filter(e => VueBusiness.getVueRoot().atribuicaoAtiva(e.id));
  },

  dominiosAtivos(permitirGeral = false){
    return DominioBusiness.getDominios().filter(e => VueBusiness.getVueRoot().atribuicaoAtiva(e.atribuicao, permitirGeral));
  },

  getSimpleDominiosAtivos(permitirGeral = false){
    return DominioBusiness.dominiosAtivos(permitirGeral).map(e => ({id: e.id, nome: e.nomeCompleto}));
  },

  getDominios() {
    return [
      {id: 'PROTOCOLO_RI', nome: 'Protocolo RI', tipo : 'PROTOCOLO', atribuicao : 'RI', genero: 'o', nomeCompleto: 'Protocolo RI'},
      {id: 'CERTIDAO_RI', nome: 'Certidão RI', tipo : 'PEDIDO_CERTIDAO', atribuicao : 'RI', genero: 'o', nomeCompleto: 'Pedido de Certidão RI'},

      {id: 'PROTOCOLO_RTD', nome: 'Protocolo RTD', tipo : 'PROTOCOLO', atribuicao : 'RTD', genero: 'o', nomeCompleto: 'Protocolo RTD'},
      {id: 'CERTIDAO_RTD', nome: 'Certidão RTD', tipo : 'PEDIDO_CERTIDAO', atribuicao : 'RTD', genero: 'o', nomeCompleto: 'Pedido de Certidão RTD'},

      {id: 'PROTOCOLO_RCPJ', nome: 'Protocolo RCPJ', tipo : 'PROTOCOLO', atribuicao : 'RCPJ', genero: 'o', nomeCompleto: 'Protocolo RCPJ'},
      {id: 'CERTIDAO_RCPJ', nome: 'Certidão RCPJ', tipo : 'PEDIDO_CERTIDAO', atribuicao : 'RCPJ', genero: 'o', nomeCompleto: 'Pedido de Certidão RCPJ'},

      {id: 'SERVICO_TN', nome: 'Serviço TN', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'o', nomeCompleto: 'Serviço TN'},
      {id: 'CERTIDAO_TN', nome: 'Certidão TN', tipo : 'PEDIDO_CERTIDAO', atribuicao : 'NOTAS', genero: 'o', nomeCompleto: 'Pedido de Certidão TN'},
      {id: 'ESCRITURA', nome: 'Escritura', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'a', nomeCompleto: 'Escritura'},
      {id: 'PROCURACAO', nome: 'Procuração', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'a', nomeCompleto: 'Procuração'},
      {id: 'SUBSTABELECIMENTO', nome: 'Substabelecimento', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'o', nomeCompleto: 'Substabelecimento'},
      {id: 'TESTAMENTO', nome: 'Testamento', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'o', nomeCompleto: 'Testamento'},
      {id: 'ATA_NOTARIAL', nome: 'Ata Notarial', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'a', nomeCompleto: 'Ata Notarial'},
      {id: 'ABONO_SINAL_PUBLICO', nome: 'Abono de Sinal Público', tipo : 'PROTOCOLO', atribuicao : 'NOTAS', genero: 'o', nomeCompleto: 'Abono de Sinal Público'},

      {id: 'NOTIFICACAO', nome: 'Notificação', tipo : 'AUXILIAR', atribuicao : 'GERAL', genero: 'a', nomeCompleto: 'Notificação'},
      {id: 'OCORRENCIA', nome: 'Ocorrência', tipo : 'AUXILIAR', atribuicao : 'GERAL', genero: 'a', nomeCompleto: 'Ocorrência'},
      {id: 'OFICIO', nome: 'Ofício', tipo : 'AUXILIAR', atribuicao : 'GERAL', genero: 'o', nomeCompleto: 'Ofício'},
      {id: 'PERSONALIZADO', nome: 'Processos Personalizados', tipo : 'AUXILIAR', atribuicao : 'GERAL', genero: 'o', nomeCompleto: 'Processos Personalizados'},
      {id: 'DOCUMENTACAO', nome: 'Documentação', tipo : 'AUXILIAR', atribuicao : 'GERAL', genero: 'a', nomeCompleto: 'Documentação'},
    ];
  },

  getDominiosProtocoloRtdRcpjUnificado() {
    return [
      {id: 'PROTOCOLO_RI', nome: 'Protocolo RI', tipo : 'PROTOCOLO', atribuicao : 'RI', genero: 'o', nomeCompleto: 'Protocolo RI'},
      {id: 'PROTOCOLO_RTD_RCPJ', nome: 'Protocolo RTD e RCPJ', tipo : 'PROTOCOLO', atribuicao : 'RTD_RCPJ', genero: 'o', nomeCompleto: 'Protocolo RTD e RCPJ'},
    ];
  },

  getDominio(dominio) {
    return DominioBusiness.getDominios().find(d => d.id === dominio)
      || dominiosLegado.find(d => d.id === dominio);
  },

  getDominioCertidao(dominio) {
    switch (dominio) {
      case 'PROTOCOLO_RI':
      case 'CERTIDAO_RI':
        return 'CERTIDAO_RI';
      case 'PROTOCOLO_RTD':
      case 'CERTIDAO_RTD':
        return 'CERTIDAO_RTD';
      case 'PROTOCOLO_RCPJ':
      case 'CERTIDAO_RCPJ':
        return 'CERTIDAO_RCPJ';
      case 'SERVICO_TN':
      case 'CERTIDAO_TN':
      case 'ESCRITURA':
      case 'PROCURACAO':
      case 'SUBSTABELECIMENTO':
      case 'TESTAMENTO':
      case 'ATA_NOTARIAL':
        return 'CERTIDAO_TN';
      default:
        return null;
    }
  },

  isProtocoloRI(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'PROTOCOLO_RI';
  },

  isProtocolo(dominio) {
    return DominioBusiness.getDominio(dominio)?.tipo == 'PROTOCOLO';
  },

  isPedidoCertidao(dominio) {
    return DominioBusiness.getDominio(dominio)?.tipo == 'PEDIDO_CERTIDAO';
  },

  isProtocoloOrCertidao(dominio) {
    return DominioBusiness.isProtocolo(dominio) || DominioBusiness.isPedidoCertidao(dominio);
  },

  isNotificacao(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'NOTIFICACAO';
  },

  isOcorrencia(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'OCORRENCIA';
  },

  isNotificacaoOuOcorrencia(dominio) {
    return DominioBusiness.isNotificacao(dominio) || DominioBusiness.isOcorrencia(dominio);
  },

  isDominioRI(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'RI';
  },

  isDominioRTD(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'RTD';
  },

  isDominioRCPJ(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'RCPJ';
  },

  isDominioNotas(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'NOTAS';
  },

  isDominioEspecificoNotas(dominio) {
    return ['CERTIDAO_TN', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'TESTAMENTO', 'ATA_NOTARIAL'].includes(DominioBusiness.getDominio(dominio)?.id);
  },

  getDominiosLivroUnico() {
    return ['ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'TESTAMENTO', 'ATA_NOTARIAL'];
  },

  getDominiosLivroUnicoCompleto() {
    return DominioBusiness.getDominiosLivroUnico().map((id) => DominioBusiness.getDominio(id)).filter((dominio) => dominio);
  },

  isDominioLivroUnicoNotas(dominio) {
    return DominioBusiness.getDominiosLivroUnico().includes(DominioBusiness.getDominio(dominio)?.id);
  },

  isProtocoloNotas(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'NOTAS' && DominioBusiness.isProtocolo(dominio);
  },

  isDominioRTDPJ(dominio) {
    return ['RCPJ', 'RTD'].includes(DominioBusiness.getDominio(dominio)?.atribuicao);
  },

  isDominioComControleExterno(dominio) {
    return ['PROTOCOLO_RI', 'CERTIDAO_RI', 'PROTOCOLO_RTD', 'CERTIDAO_RTD', 'PROTOCOLO_RCPJ', 'CERTIDAO_RCPJ'].includes(dominio);
  },

  isTarefa(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'PERSONALIZADO';
  },

  isEscritura(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'ESCRITURA';
  },

  isServico(dominio) {
    return DominioBusiness.getDominio(dominio)?.id == 'SERVICO_TN';
  },

  isTabelionato(dominio) {
    return DominioBusiness.getDominio(dominio)?.atribuicao == 'NOTAS';
  },

  dominiosAuxiliares(){
    return ['NOTIFICACAO', 'OFICIO', 'OCORRENCIA', 'PERSONALIZADO'];
  },

  isDominioAuxiliar(dominio) {
    return DominioBusiness.dominiosAuxiliares().includes(dominio);
  },

  isFichaExterna(ficha) {
    return ficha?.tipoFicha === 'externa';
  },

  getTiposProtocoloPorDominio(dominio, simples = false){

    if(DominioBusiness.isPedidoCertidao(dominio)){
      return [
        {id: 'NORMAL', nome: 'Normal'},
        {id: 'ORCAMENTO', nome: 'Orçamento'}
      ];
    }

    let isNotas = DominioBusiness.isDominioNotas(dominio);

    if(DominioBusiness.isProtocolo(dominio) || isNotas){
      if(simples && ['PROTOCOLO_RI'].includes(dominio)){
        return [
          {id: 'NORMAL', nome: 'Normal'},
          {id: 'PROCESSO_INTERNO', nome: 'Processo Interno'}
        ];
      }

      return [
        {id: 'NORMAL', nome: 'Normal'},
        {id: 'EXAME_CALCULO', nome: 'Exame e Cálculo'},
        ['PROTOCOLO_RI'].includes(dominio) || isNotas ? {id: 'PROCESSO_INTERNO', nome: 'Processo Interno'} : null,
        {id: 'ORCAMENTO', nome: 'Orçamento'}
      ].filter(e => e);
    }

    if(dominio == 'OFICIO'){
      return [
        {id: 'ENVIADO', nome: 'Enviado'},
        {id: 'RECEBIDO', nome: 'Recebido'}
      ];
    }

    return [];
  },

  getLabelCustas(dominio, plural = false) {
    return DominioBusiness.isServico(dominio) ? (plural ? 'Serviços' : 'Serviço') : (plural ? 'Custas Adicionais' : 'Custa Adicional');
  },

  getDominioProtocolo() {
    if (VueBusiness.getVueRoot().config.livros.protocoloSequenciaIgualRtdRcpj) {
      return DominioBusiness.getDominiosProtocoloRtdRcpjUnificado();
    } else {
      return DominioBusiness.dominiosAtivos().filter(e => e.tipo === 'PROTOCOLO').map(e => ({id: e.id, nome: e.nomeCompleto}));
    }
  },

  getDominiosFiltradosPorAtribuicao() {
    let lista  = DominioBusiness.getDominiosProtocoloRtdRcpjUnificado();
    if (!VueBusiness.getVueRoot().isAtribuicaoRTD || !VueBusiness.getVueRoot().isAtribuicaoRCPJ) {
      lista = lista.filter(dominio => dominio !== 'PROTOCOLO_RTD_RCPJ');
    }
    if(!VueBusiness.getVueRoot().isAtribuicaoRI){
      lista = lista.filter(dominio => dominio !== 'PROTOCOLO_RI');
    }
    return lista;
  },

  getDominiosDOI() {
    let lista  = [];
    if(VueBusiness.getVueRoot().isRI){
      lista.push(DominioBusiness.getDominio('PROTOCOLO_RI'));
    }
    if(VueBusiness.getVueRoot().isRTD){
      lista.push(DominioBusiness.getDominio('PROTOCOLO_RTD'));
    }
    return lista;
  }

}
